// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-box[data-v-575efae3]{border:1px solid #ddd;padding:10px}.ls-box .item[data-v-575efae3]{position:relative}.ls-box .item .prev[data-v-575efae3]{position:absolute;bottom:100%;left:0;display:none;overflow:auto;z-index:99;border:1px solid #333}.ls-box .item .prev img[data-v-575efae3]{display:block;max-width:500px}", ""]);
// Exports
module.exports = exports;
